module.exports = __webpack_public_path__ + "static/img/img-default@2x.fd822654.png";